import {fetchAPI} from "../lib/api";
import {getFooterItems, getNavbarItems} from "../lib/utils";
import Section_PrivacyImpressum from "../components/Section_PrivacyImpressum"

function ImpressumPage({navbarItems, impressumData, footerItems}) {
  return (
    <Section_PrivacyImpressum
      navbarItems={navbarItems}
      sectionData={impressumData}
      footerItems={footerItems}
    />
  )
}

export async function getStaticProps() {
  const [aboutRes, heroRes, privacyRes, impressumRes, servicesRes, contactRes] = await Promise.all([
    fetchAPI("/section-about", {populate: "*"}),
    fetchAPI("/section-hero", {populate: "*"}),
    fetchAPI("/section-privacy", {populate: "*"}),
    fetchAPI("/section-impressum", {populate: "*"}),
    fetchAPI("/section-services", {
      populate: ["works", "works.coverImage.media"],
    }),
    fetchAPI("/section-contact", {populate: "*"}),
  ]);

  const navbarItems = getNavbarItems({
    sectionHero: heroRes.data.attributes,
    sectionAbout: aboutRes.data.attributes,
    sectionServices: servicesRes.data.attributes,
    sectionContact: contactRes.data.attributes,
  });

  const footerItems = getFooterItems({
    sectionPrivacy: privacyRes.data.attributes,
    sectionImpressum: impressumRes.data.attributes,
  });

  return {
    props: {
      navbarItems: navbarItems,
      impressumData: impressumRes.data.attributes,
      footerItems: footerItems,
    },
    revalidate: 1,
  };
}

export default ImpressumPage
